<template>
<div>
    <Auth />
    <Reg />
    <Applying />
    <Create />
    <Help />
    <Pay />
</div>       
</template>

<script>

import Auth from '../modals/auth/auth.vue'
import Reg from '../modals/reg/reg.vue'
import Applying from '../modals/applying/applying.vue'
import Create from '../modals/ticketCreate/create.vue' 
import Help from '../modals/help/help.vue'
import Pay from '../modals/pay/pay.vue'

export default {
  components: { Help, Auth, Reg, Applying, Create, Pay},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// modal.vue?dce89ebc